import React, {useEffect, useState} from 'react';
import {presignS3Url} from '_logics/LFCS3Presign';

/**
 * S3 会社バケットの画像を presigned URL で表示する img 互換コンポーネント。
 * src が S3 会社バケット以外（公開バケット・data URL・ローカルパス等）の場合は
 * そのままの URL で表示する。presign 失敗時も元 URL にフォールバックする。
 */
const LFCS3Image: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({src, alt, ...rest}) => {
  const [resolvedSrc, setResolvedSrc] = useState<string | undefined>(undefined);

  useEffect(() => {
    let active = true;
    if (src == null || src === '') {
      setResolvedSrc(undefined);
      return;
    }
    presignS3Url(src)
      .then(url => {
        if (active) setResolvedSrc(url);
      })
      .catch(() => {
        if (active) setResolvedSrc(src);
      });
    return () => {
      active = false;
    };
  }, [src]);

  return <img {...rest} src={resolvedSrc} alt={alt ?? ''} />;
};

export default LFCS3Image;
